import type { ReactNode } from 'react';
import type { MSlotProps } from '../MSlot/MSlot.types';

export enum MTabGroupAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export type MTabGroupTab = {
  label: string;
  description?: string;
  iconName?: string;
  content?: ReactNode;
  mSlot?: Partial<MSlotProps>;
};

export type MTabGroupProps = {
  alignment?: MTabGroupAlignment;
  icon?: boolean;
  description?: boolean;
  tabs: MTabGroupTab[];
  className?: string;
  onTabChange?: (index: number) => void;
};
